
import { computed, ComputedRef, defineComponent, onMounted } from "vue";
import { ContentType } from "../../../../domain/entities/content/content";
import { Content } from "./helpers";
import { useStore } from "vuex";
import ContentControls from "./ContentControls.vue";
import ContentComplements from "./ContentComplements.vue";
import ContentTabMenu from "./ContentTabMenu.vue";
import ContentRating from "./ContentRating.vue";
import ContentInteraction from "./ContentInteraction.vue";
import {
  ContentProvider,
  ContentProviderType
} from "../../../../domain/entities/content-provider/content-provider";
import MP3Viewer from "./MP3viewer.vue";
import YouTubeViewer from "./YouTubeViewer.vue";
import PDFViewer from "./PDFviewer.vue";
import ExerciseViewer from "./ExerciseViewer.vue";
import SearchFormViewer from "./SearchFormViewer.vue";
import SCORMViewer from "./SCORMViewer.vue";
import TUIViewer from "../../components/application/TUIViewer.vue";
import ContentFallback from "../../components/application/moldure/ContentFallback.vue";
import ContentHeader from "./ContentHeader.vue";
import { useRoute, useRouter } from "vue-router";
import { removeQuery } from "../../utils/routing_utils";

export default defineComponent({
  name: "ContentMain",
  components: {
    ContentHeader,
    ContentFallback,
    TUIViewer,
    MP3Viewer,
    PDFViewer,
    YouTubeViewer,
    ExerciseViewer,
    SearchFormViewer,
    SCORMViewer,
    ContentInteraction,
    ContentRating,
    ContentTabMenu,
    ContentComplements,
    ContentControls
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    onMounted(
      async (): Promise<void> => {
        await scrollToDoubtsSection();
      }
    );

    const currentContent: ComputedRef<Content> = computed(
      () => store.getters["content_module/currentContent"]
    );

    const contentProvider: ComputedRef<ContentProvider> = computed(
      () => store.getters["content_module/contentProvider"]
    );

    const viewer = new Map<ContentType, string>([
      [ContentType.YOUTUBE, "YouTubeViewer"],
      [ContentType.MP3, "MP3Viewer"],
      [ContentType.PDF, "PDFViewer"],
      [ContentType.SCORM, "SCORMViewer"],
      [ContentType.EXERCISE, "ExerciseViewer"],
      [ContentType.SEARCHFORM, "SearchFormViewer"]
    ]);

    const scrollToDoubtsSection = async (): Promise<void> => {
      const doubts = document.getElementById(
        "content-interaction"
      ) as HTMLDivElement;
      if (doubts && route.query.notification) {
        const elementTop = doubts.offsetTop + doubts.scrollWidth;
        window.scrollTo({ top: elementTop, behavior: "smooth" });
        await removeQuery(router, "notification");
      }
    };

    return {
      currentContent,
      contentProvider,
      ContentProviderType,
      ContentType,
      viewer
    };
  }
});
